<template>
  <el-container>
    <el-main v-if="classroom.id">

      <div style="background-color: #F5402F;" class="alert alert-danger" v-if="classroom.historic == '1' && classroom.isPublic == '0'"><span><b> Status - Cancelled</b><br> This classroom has been cancelled. It will not show on the website, please make sure students have been re-allocated.</span></div>
      <div style="background: #FBC14A; color:#fff;" class="alert alert-warning" v-if="classroom.historic != '1' && classroom.isPublic == '0'"><span><b> Status - Inactive</b><br>This classroom is not currently active and will not show on the website.</span></div>
      <div style="background: #29917d; color:#fff;" class="box-card alert alert-success" v-if="classroom.historic != '1' && classroom.isPublic == '1'"><span><b> Status - Active</b><br>This classroom is active and will show as available on the website if it is in the future and has spaces available</span></div>
            
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="8">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Summary</h4>
            </div>
            <!-- DISPLAY STATUS OF CLASSROOM -->
            <div class="card-content">
              <el-form :model="classroom" :rules="rules" ref="classroom" label-width="120px" class>
                
                <el-form-item label="Venue Name">
                  <el-input
                    v-if="classroom.venue"
                    maxlength="8"
                    disabled
                    v-model="classroom.venue.name"
                  ></el-input>
                  <br />
                  <small>To change the venue please use the venue dropdown</small>
                </el-form-item>

                <el-form-item label="Code" prop="code">
                  <el-input maxlength="8" v-model="classroom.code"></el-input>
                </el-form-item>

                 <el-form-item label="isOnline">
                  <el-checkbox v-model="classroom.isOnline"></el-checkbox>
                </el-form-item>

                <el-form-item v-if="classroom.isOnline" label="Meeting Url">
                    <el-input v-model="classroom.meetingUrl"></el-input>
                </el-form-item>

                <el-form-item v-if="classroom.isOnline" label="Meeting ID">
                    <el-input v-model="classroom.meetingID"></el-input>
                </el-form-item>

                <el-form-item v-if="classroom.isOnline " label="Sessions">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                      type="dates"
                      @change="setStartDate"
                      v-model="classroom.sessions"
                      placeholder="Pick one or more dates">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="Start Date" prop="startDate">
                  <el-date-picker
                    v-model="classroom.startDate"
                    type="date"
                    placeholder="Pick a day"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label="End Date" prop="endDate">
                  <el-date-picker 
                    v-model="classroom.endDate" 
                    type="date" 
                    placeholder="Pick a day"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label="Start Time" prop="startTime">
                  <el-time-select
                     value-format="HH:mm"
                     format="HH:mm"
                    v-model.lazy="classroom.startTime"
                    :picker-options="{
                      start: '01:00',
                      step: '01:00',
                      end: '24:00'
                    }"
                    placeholder="Pick a time"
                  ></el-time-select>
                </el-form-item>

                <el-form-item label="End Time" prop="endTime">
                  <el-time-select
                    v-model.lazy="classroom.endTime"
                    value-format="HH:mm"
                    :picker-options="{
                      start: '01:00',
                      step: '01:00',
                      end: '24:00'
                    }"
                    placeholder="Pick a time"
                  ></el-time-select>
                </el-form-item>

                <el-form-item label="Active">
                  <el-checkbox v-model="checked"></el-checkbox>
                </el-form-item>

                <el-form-item label="Tutor" prop="tutor">
                  <el-select
                    size="large"
                    class="form-group border-input"
                    placeholder="Select Tutor"
                    v-model="tutor"
                    value-key="id"
                    @change="classroom.tutorId = tutor.id"
                  >
                    <el-option
                      v-for="tutor in tutors"
                      class="select-default"
                      :value="tutor"
                      :label="tutor.firstname + ' ' + tutor.lastname"
                      :key="tutor.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Venue" prop="venue">
                  <el-select
                    size="large"
                    v-if="classroom.venue"
                    class="form-group border-input"
                    placeholder="Select Venue"
                    v-model="venue"
                    value-key="id"
                    @change="classroom.venueId = venue.id"
                  >
                    <el-option
                      v-for="venue in venues"
                      class="select-default"
                      :value="venue"
                      :label="venue.name"
                      :key="venue.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Max Attendees" prop="maxattendees">
                  <el-input style="width:50px" maxlength="2" v-model="classroom.maxAttendees"></el-input>
                </el-form-item>

                <div class="text-center">
                  <el-button v-if="classroom.historic != '1'" type="primary" @click="updateClassroom('classroom')">Update</el-button>
                  <el-button v-if="classroom.historic != '1'" type="warning" @click="toggleCancel()">Cancel</el-button>
                  <el-button v-if="classroom.historic == '1' && classroom.isPublic == '0'" type="warning" @click="toggleRestore()">Restore</el-button>
                  <el-button type="danger" @click="toggleDialog()">Delete</el-button>
                  <el-button type="danger" @click="resetFields('classroom')">Reset</el-button>
                </div>
              </el-form>
            </div>
          </el-card>
          <el-card class="box-card" style="margin-top:30px;">
            <div class="card-header">
              <h4 class="card-title">Ratings</h4>
            </div>
            <div class="card-content">
              <h6>Course</h6>
              <el-rate
                v-model="courseRating"
                disabled
                show-score
                text-color="#ff9900"
                :max="10.00"
                score-template="{value}"
              ></el-rate>
              <h6>Service</h6>
              <el-rate
                v-model="serviceRating"
                disabled
                show-score
                text-color="#ff9900"
                :max="10.00"
                score-template="{value}"
              ></el-rate>
              <h6>Tutor</h6>
              <el-rate
                v-model="tutorRating"
                disabled
                show-score
                text-color="#ff9900"
                :max="10.00"
                score-template="{value}"
              ></el-rate>
              <h6>Venue</h6>
              <el-rate
                v-model="venueRating"
                disabled
                show-score
                text-color="#ff9900"
                :max="10.00"
                score-template="{value}"
              ></el-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">
                Attendees ({{classroom.maxAttendees}} max)
                <small
                  class="label label-info pull-right"
                  v-if="classroom.maxAttendees - classroom.numAttendees === 0"
                >Fully booked!</small>
                <small
                  class="label label-success pull-right"
                  v-if="classroom.maxAttendees - classroom.numAttendees <= 5 && classroom.maxAttendees - classroom.numAttendees > 0"
                >{{classroom.maxAttendees - classroom.numAttendees}} remaining</small>
                <small
                  class="label label-warning pull-right"
                  v-if="classroom.maxAttendees - classroom.numAttendees <= 10 && classroom.maxAttendees - classroom.numAttendees > 5"
                >{{classroom.maxAttendees - classroom.numAttendees}} remaining</small>
                <small
                  class="label label-danger pull-right"
                  v-if="classroom.maxAttendees - classroom.numAttendees > 10"
                >{{classroom.maxAttendees - classroom.numAttendees}} remaining</small>
              </h4>
            </div>
            <div class="card-content">
                            <!--<div class="form-group">
                <label class="control-label">Max Students</label>
                <el-input v-model="classroom.maxAttendees"></el-input>
                <el-button :loading="loadingRegister" @click="generateRegister()">Generate Register</el-button>
              </div>-->

              <div class="form-group text-right" style="padding:15px 0">
                <el-button :loading="loadingRegister" icon="el-icon-document" type="primary" @click="generateRegister()">Generate Register</el-button>
                <el-button type="success" icon="el-icon-message" @click="emailAllVisible = true">Email All Attendees</el-button>&nbsp;
                <router-link :to="classroom.isOnline && classroom.code.substring(0,3)=='OTP'?'/tutors/register-online/'+$route.params.id:'/tutors/register/'+$route.params.id">
                  <el-button type="warning" icon="el-icon-edit">Edit Register</el-button>
                </router-link>
              </div>

              <el-table
                class="table-shopping"
                style="width: 100%"
                :data="classroom.attendees"
                border
              >
                <el-table-column label="id" min-width="8">
                  <template slot-scope="props">
                    <small>{{props.row.id}}</small>
                  </template>
                </el-table-column>
                <el-table-column label="Name" min-width="14">
                  <template slot-scope="props">
                    <small>{{props.row.customer.firstname}} {{props.row.customer.lastname}}</small>
                  </template>
                </el-table-column>
                <el-table-column label="Email" min-width="17">
                  <template slot-scope="props">
                    <small>{{props.row.customer.email}}</small>
                  </template>
                </el-table-column>
                <el-table-column label="Attended" min-width="8">
                  <template slot-scope="props">
                    <el-checkbox
                      :checked="props.row.attended=='1'?true:false"
                      disabled
                      v-model="props.row.attended"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="Passed" min-width="8">
                  <template slot-scope="props">
                    <el-checkbox
                      :checked="props.row.passed=='1'?true:false"
                      disabled
                      v-model="props.row.passed"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="LOR" min-width="9">
                  <template slot-scope="props">
                    <a
                      v-show="props.row.lorSourceUrl"
                      class="btn btn-primary"
                      target="_blank"
                      :href="props.row.lorSourceUrl.substring(0,3)=='app' ? 'https://crm.tefl.org.uk/'+props.row.lorSourceUrl : props.row.lorSourceUrl"
                    >view</a>
                  </template>
                </el-table-column>
                <el-table-column label="Edit" min-width="5">
                  <template slot-scope="props">
                    <router-link
                      v-if="props.row.customer"
                      :to="'/customer/edit/'+props.row.customer.id"
                    >Edit</router-link>
                  </template>
                </el-table-column>
              </el-table>
              <!--<el-button type="primary" @click="emailAllVisible = true">Email All Attendees</el-button>-->
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-card class="box-card" style="margin-top:30px;" v-if="feedback">
            <h4 class="card-title">Classroom Feedback</h4>
            <div class="card-header">
              <div class="card-content">
                <el-row style="margin-top:30px; margin-bottom: 10px"></el-row>

                <data-tables-server
                  class="table-shopping"
                  style="width: 100%"
                  :data="feedback"
                  :tool-bar="false"
                  :current-page="1"
                  :total="feedbackTotal"
                  :loading="loadingFeedback"
                  :page-size="20"
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
                >
                  <el-table-column label="Name" min-width="15">
                    <template
                      slot-scope="props"
                      v-if="props.row.customer"
                    >{{props.row.customer.firstname}} {{props.row.customer.lastname}}</template>
                  </el-table-column>

                  <el-table-column label="Date" min-width="10">
                    <template slot-scope="props">{{props.row.dateUpdated | moment('DD MMM YYYY')}}</template>
                  </el-table-column>

                  <el-table-column label="Rating" min-width="8">
                    <template slot-scope="props">{{props.row.tutorRating}}/10</template>
                  </el-table-column>

                  <el-table-column label="What did the student like most" min-width="40">
                    <template slot-scope="props">{{props.row.likeMost}}</template>
                  </el-table-column>

                  <el-table-column label="What would the student improve" min-width="40">
                    <template slot-scope="props">{{props.row.improve}}</template>
                  </el-table-column>
                </data-tables-server>
              </div>
            </div>
            <div class="card-content"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>

    <el-dialog
      title="Email All Attendees"
      :visible.sync="emailAllVisible "
      width="30%"
      :modal="false"
    >
      <div class="form-group">
        <label>Email Subject</label>
        <br />
        <el-input maxlength="100" v-model="emailMessage.title"></el-input>
      </div>
      <label>Email Content</label>
      <br />
      <VuePellEditor
        v-model="emailMessage.text"
        :style-with-css="false"
        default-paragraph-separator="p"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailAllVisible  = false">Cancel</el-button>
        <el-button type="primary" @click="emailAttendees()">Send</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Confirm Delete" :visible.sync="dialogVisible" width="30%" :modal="false">
      <span>This will permanently delete the classroom, are you sure?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">No, go back</el-button>
        <el-button type="danger" @click="deleteClassroom()">Yes, permanently delete this classroom</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Confirm Cancel" :visible.sync="cancelVisible" width="30%" :modal="false">
      <span>This will cancel the classroom, are you sure?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelVisible = false">No, go back</el-button>
        <el-button type="warning" @click="cancelClassroom()">Yes, cancel this classroom</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Confirm Restore" :visible.sync="restoreVisible" width="30%" :modal="false">
      <span>This will restore (un-cancel) the classroom, are you sure?<br>Note: It will remain inactive until manually set to active.</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelVisible = false">No, go back</el-button>
        <el-button type="warning" @click="restoreClassroom()">Yes, restore this classroom</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>
<script>
import api from "./api";

import VenueFilter from "../UIComponents/VenueFilter.vue";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
import VuePellEditor from "vue-pell-editor";

const UPDATE_CLASSROOM=gql`
mutation updateClassRoom($id: Int, $classroom: ClassRoom_set_input){
  update_ClassRoom(
    where: {id: {_eq: $id}}
    _set: $classroom
  ){
    returning {
      id
      venueId
      venue {
        id
        country
        name
        town
      }
      tutorId
      tutor {
        id
        firstname
        lastname
      }
      attendees {
        id
        attended
        passed
        lorSourceUrl
        customer {
          id
          firstname
          lastname
          email
        }
      }
      isPublic
      isOnline
      startDate
      endDate
      startTime
      sessions
      endTime
      meetingUrl
      meetingID
      length
      code
      numAttendees
      maxAttendees
      courseRatingPercentage
      recommendedPercentage
      serviceRatingPercentage
      tutorRatingPercentage
      venueRatingPercentage
    }
    affected_rows
  }
}
`;

export default {
  components: {
    VuePellEditor,
    VenueFilter
  },
  data() {
    return {
      checked: false,
      emailAllVisible: false,
      dialogVisible: false,
      cancelVisible: false,
      restoreVisible: false,
      loadingRegister: false,
      emailMessage: { title: "", text: "" },
      classroom: {sessions:[]},
      feedback: [],
      attendees: [],
      courseRating: 0,
      serviceRating: 0,
      tutorRating: 0,
      venueRating: 0,
      selectedTutor: {},
      tutor: {},
      venues: [],
      venue: "",
      tutors: [],
      rules: {},
      loadingFeedback: false,
      feedbackTotal: 0,
      feedbackAggregate: {},
      calendarConfigs: {
        sundayStart: false,
        dateFormat: 'dd/mm/yyyy',
        isModal:true,
        isMultipleDatePicker:true
      },
      rules: {
        endDate: [
          { required: true, message: 'Please pick an end date', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: 'Please pick a start date', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
      
    setStartDate(d){
      console.log('date: ',d);
      if(Array.isArray(d)) {
        this.classroom.startDate=d[0]
        this.classroom.endDate=d[d.length-1]
      } else {
        this.classroom.startDate=d
      }
    },

    getClassroom(id) {
      var today = this.today;
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          fetchPolicy: "no-cache",
          query: gql`
          
            {
              ClassRoom(where: {id: {_eq: "${id}"}}) {
                id
                code
                venueId
                venue {
                  id
                  country
                  name
                  town
                }
                tutorId
                tutor {
                  id
                  firstname
                  lastname
                }
                attendees{
                  id
                  attended
                  passed
                  lorSourceUrl
                  classAgree
                  classAgreeDate
                  customer{
                    id
                    firstname
                    lastname
                    email
                  }
                }
                isOnline
                isPublic
                startDate
                endDate
                startTime
                endTime
                historic
                isOnline
                meetingUrl
                meetingID
                sessions
                length
                code
                numAttendees
                maxAttendees
                courseRatingPercentage
                recommendedPercentage
                serviceRatingPercentage
                tutorRatingPercentage
                venueRatingPercentage
              }
            }
          
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.classroom = response.data.ClassRoom[0];
    
          this.checked = this.classroom.isPublic==1 ? true:false;
         
          this.courseRating = Number(
            (this.classroom.courseRatingPercentage / 10).toFixed(2)
          );
          this.serviceRating = Number(
            (this.classroom.serviceRatingPercentage / 10).toFixed(2)
          );
          this.tutorRating = Number(
            (this.classroom.tutorRatingPercentage / 10).toFixed(2)
          );
          this.venueRating = Number(
            (this.classroom.venueRatingPercentage / 10).toFixed(2)
          );
          this.tutor = this.classroom.tutor;
          this.venue = this.classroom.venue;
          this.getTutors();
          this.getVenuesByTown(this.classroom.venue.town);
          /*this.getTutorVenue(
            this.classroom.tutor.id,
            this.classroom.venue.id
          );*/
          //this.boughtProducts = response.data.Order[0].boughtProducts;
          //console.log("Order: ", this.order.id);
          this.loadingOrders = false;
          //this.getBoughtProducts(this.order.id);
        });
    },

    emailAttendees() {
      let attendees = this.classroom.attendees.map(att => {
        return att.customer.email;
      });
      let notes = this.classroom.attendees.map(att => {
        return `{customerId:${att.customer.id},detail:"<h3>Email to all Attendees</h3><p>Subject:<br />${this.emailMessage.title}</p><p>Message:<br />${this.emailMessage.text}<p>", createdBy: "${this.user.email}",dateCreated:"${moment().format('YYYY-MM-DDTHH:mm:ss')}"}`
      });
      api
        .emailAttendees({ message: this.emailMessage, attendees: attendees })
        .then(res => {
          this.emailAllVisible = false;
          this.$notify({
            title: "Emails Sent",
            message: "Email was sent",
            type: "success"
          });
          //insert a note on he account
          console.log(notes)
      let q=gql`
      mutation AddNote {
          insert_Note(objects: [${notes}]) {
            affected_rows
          }
      }`
     this.$apollo
     .mutate({
           mutation: q
        }).then(result => {
       this.$notify({
            title: "Copy saved in Notes",
            message: "A copy of the email was saved into the customer notes",
            type: "success"
          });
        })
        })
    },

    updateClassroom(formName) {

      this.classroom.isPublic = this.checked ? 1 : 0;
      this.classroom.dateUpdated = moment(); 

      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$apollo.mutate({
              mutation:UPDATE_CLASSROOM,
              variables:{
                id: this.classroom.id,
                classroom: _.omit(this.classroom, [
                    "attendees",
                    "tutor",
                    "venue",
                    "__typename"
                  ])
              }
            }).then(response => {
                this.$notify({
                  title: "Update Classroom",
                  message: "Classroom Updated",
                  type: "success"
                });
                this.classroom = response.data.update_ClassRoom.returning[0];
                this.checked = !!this.classroom.isPublic;
                this.courseRating = Number(
                  (this.classroom.courseRatingPercentage / 10).toFixed(2)
                );
                this.serviceRating = Number(
                  (this.classroom.serviceRatingPercentage / 10).toFixed(2)
                );
                this.tutorRating = Number(
                  (this.classroom.tutorRatingPercentage / 10).toFixed(2)
                );
                this.venueRating = Number(
                  (this.classroom.venueRatingPercentage / 10).toFixed(2)
                );
                this.tutor = this.classroom.tutor;
                this.venue = this.classroom.venue;
                this.getTutors();
                if(this.classroom.venue)
                this.getVenuesByTown(this.classroom.venue.town);
                /*this.getTutorVenue(
                  this.classroom.tutor.id,
                  this.classroom.venue.id
                );*/
                //this.boughtProducts = response.data.Order[0].boughtProducts;
                //console.log("Order: ", this.order.id);
                this.loadingOrders = false;
                //this.getBoughtProducts(this.order.id);
                // return result
              })
              .catch(error => {
                this.$notify({
                  title: "Error",
                  message: error.message,
                  type: "error"
                });
              });
          } else {
            this.$notify({
              title: "Error updating classroom",
              message: "Please check you have filled in the required fields",
              duration: 0,
              type: "error"
            });
            return false;
          }
        });

      
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    getFeedback(id) {
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: gql`
          {
            ClassRoomFeedback(
              where: { 
                  _and: [
                    { classRoomId: {_eq: "${id}"} }
                  ]
                }
            ) {
                id
                tutorRating
                customer {
                  firstname
                  lastname
                }
                likeMost
                improve
                dateUpdated
            }
            ClassRoomFeedback_aggregate(
              where: { 
                 _and: [
                    { classRoomId: {_eq: "${id}"} }
                  ]
                }
            ) {
              aggregate {
                count
              }
            }
          }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.feedback = response.data.ClassRoomFeedback;
          //console.log(this.feedback);
          this.feedbackAggregate =
            response.data.ClassRoomFeedback_aggregate.aggregate;
          this.feedbackTotal =
            response.data.ClassRoomFeedback_aggregate.aggregate.count;
          this.loadingFeedback = false;
        });
    },

    getOrdersByClassroomId(id) {
      api.getOrdersByClassroomId(id).then(response => {
        console.log(response);
        this.attendees = response.data;
      });
    },

    toggleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },

    toggleCancel() {
      this.cancelVisible = !this.cancelVisible;
    },

    toggleRestore() {
      this.restoreVisible = !this.restoreVisible;
    },

    deleteClassroom() {
      //Delete Classroom
      const q = gql`
        mutation delete_ClassRoom($id: Int) {
          delete_ClassRoom(where: { id: { _eq: $id } }) {
            affected_rows
          }
        }
      `;
      this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: q,
          variables: {
            id: this.classroom.id
          }
        })
        .then(result => {
          this.$notify({
            title: "Deleted",
            message: "Classroom deleted",
            type: "success"
          });
          this.$router.push({ path: "/classroom/list" });
          //return result;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
      //this.$router.push({ path: '/booking/list'})
    },

    cancelClassroom() {
      //Cancel Classroom
      //this.order = response.data.data;
      const q = gql`
        mutation cancel_ClassRoom($id: Int) {
          update_ClassRoom(where: { id: { _eq: $id } }, _set: {historic: "1", isPublic: "0"}) {
            affected_rows
            returning {
              id
            }
          }
        }
      `;
      this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: q,
          variables: {
            id: this.classroom.id
          }
        })
        .then(result => {
          this.$notify({
            title: "Cancelled",
            message: "Classroom cancelled",
            type: "success"
          });
          this.toggleCancel();
          this.getClassroom(this.$route.params.id);
          //this.$router.push({ path: "/classroom/list" });
          //return result;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
      //this.$router.push({ path: '/booking/list'})
    },

    restoreClassroom() {
      //Restore Classroom
      //this.order = response.data.data;
      const q = gql`
        mutation restore_ClassRoom($id: Int) {
          update_ClassRoom(where: { id: { _eq: $id } }, _set: {historic: "0"}) {
            affected_rows
            returning {
              id
            }
          }
        }
      `;
      this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: q,
          variables: {
            id: this.classroom.id
          }
        })
        .then(result => {
          this.$notify({
            title: "Restored",
            message: "Classroom restored",
            type: "success"
          });
          this.toggleRestore();
          this.getClassroom(this.$route.params.id);
          //this.$router.push({ path: "/classroom/list" });
          //return result;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
      //this.$router.push({ path: '/booking/list'})
    },

    async getTutors() {
      this.$apollo
        .query({
          query: gql`
            {
              Tutor(limit: 50, where: {isActive: {_eq: 1}}, order_by: {firstname: asc}) {
                id
                firstname
                lastname
              }
            }
          `,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.tutors = response.data.Tutor;
        });
    },

    getVenuesByTown(town) {
      this.$emit("loading", true);
      this.venues = [];
      if (town != "All") {
        //if (this.towns[].length === 0) {
        this.$apollo
          .query({
            query: gql`
            {
              ClassRoomVenue(
                where: { town: {_eq: "${town}"} }
              ) {
                id
                name
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            for (let venue of response.data.ClassRoomVenue) {
              this.venues.push(venue);
            }
            this.venues = this.venues.sort();
            this.$emit("loading", false);
            this.$emit("update:classVenues", this.venues);
          });
      }
    },
    generateRegister() {
      this.loadingRegister = true;
      api.generateRegisterPdf(this.classroom).then(res => {
        var dataView = new DataView(res.data);
        var fileURL = window.URL.createObjectURL(
          new Blob([dataView], { type: "application/pdf" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          this.classroom.venue.name +
            " - " +
            this.classroom.startDate +
            " - register.pdf"
        );
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingRegister = false;
      });
    }
  },
  mounted() {
    this.getClassroom(this.$route.params.id);
    this.getFeedback(this.$route.params.id);
    //this.getOrdersByClassroomId(this.$route.params.id);
  },
  computed: {
  

     user(){
        const token = localStorage.getItem('vuex')
        const parsed = JSON.parse(token)
        return parsed['auth']
      }
  },
};
</script>
<styl


// WEBPACK FOOTER //
// src/components/Classrooms/Edit.vue